import type { ISO31661Entry } from 'iso-3166';

/**
 * The countries where we want to also ask for the subdivision (state/province)
 * The subdivisions (i.e., states, provinces) are ISO-3166 alpha-2 codes
 */
export const COUNTRIES_TO_GET_SUBDIVISION: Set<ISO31661Entry['alpha2']> =
  new Set(['US', 'CA']);
